import * as React from 'react'
import { ClockListener, clock } from '../../../../common/src/clock'
import { Link } from '../../../../common/src/components/Link'
import Table from '../../../../common/src/components/Table'
import { BodyText } from '../../../../common/src/components/core'
import { fmtHMS, diffSecs, diffFmt } from '../../../../common/src/date'
import { FetchJobsQuery } from '../../../../common/src/types.gen'

interface JobsTableProps {
  jobs: FetchJobsQuery['jobs']
  compact?: boolean
  emptyElem?: JSX.Element
  collapsedNumRows?: number
}

export default class JobsTable extends React.PureComponent<
  JobsTableProps,
  {
    isExpanded: boolean
    timeNow: string
  }
> {
  private onClockBound?: ClockListener

  state = {
    isExpanded: false,
    timeNow: clock.now(),
  }

  componentDidMount() {
    this.onClockBound = timeNow => this.setState({ timeNow })
    clock.addListener(this.onClockBound)
  }

  componentWillUnmount() {
    clock.removeListener(this.onClockBound!)
  }

  render() {
    const { jobs, emptyElem, compact, collapsedNumRows } = this.props
    const { isExpanded, timeNow } = this.state

    if (jobs == null) {
      return null
    }

    const collapsedNR = collapsedNumRows == null ? 5 : collapsedNumRows
    const jobsToShow = isExpanded || jobs.length < collapsedNR ? jobs : jobs.slice(0, collapsedNR)
    const numHidden = jobs.length - jobsToShow.length
    const widths = compact ? this.widthsCompact : this.widthsFull

    const cols = [
      (t: FetchJobsQuery['jobs'][0]) => t.jobName,
      (t: FetchJobsQuery['jobs'][0]) => (this.props.compact ? t.jobStatus.substring(0, 3) : t.jobStatus),
      (t: FetchJobsQuery['jobs'][0]) => fmtHMS(diffSecs(t.timeFinished || timeNow, t.timeCreated)),
      (t: FetchJobsQuery['jobs'][0]) => t.timeFinished != null && diffFmt(timeNow, t.timeFinished) + ' ago',
      (t: FetchJobsQuery['jobs'][0]) => <Link href={'/leasing/data/job?id=' + t.id}>Raw</Link>,
    ]

    return (
      <div>
        <Table rows={jobsToShow} widths={widths} alignments={this.aligns} columns={cols} />
        <BodyText>
          {jobs.length === 0 && (emptyElem || 'No jobs in last 15 days')}
          {(isExpanded || numHidden > 0) && (
            <Link onClick={this.toggleExpandBound} color="snow">
              {isExpanded ? 'Hide history' : '+' + numHidden + ' more'}
            </Link>
          )}
        </BodyText>
      </div>
    )
  }

  private aligns = ['left', 'left', 'right', 'right', 'right']

  private widthsCompact = [null, '32px', '32px', '48px', '36px']

  private widthsFull = [null, '96px', '50px', '72px', '44px']

  private toggleExpandBound = () => this.setState({ isExpanded: !this.state.isExpanded })
}
